import { ProfessionalPartnershipFormData } from '../../../types/forms'
import { OnboardingFormState } from '../../../types/state'
import { getSelectedCompany } from './getSelectedCompany'
import { setNewCompanies } from './setNewCompanies'

export const professionalPartnershipsToState = ({
  companyIndex,
  currentState,
  formData
}: {
  companyIndex: number
  currentState: OnboardingFormState
  formData: ProfessionalPartnershipFormData
}) => {
  const oldCompany = getSelectedCompany({ companyIndex, currentState })

  // change ref in list
  const newCompaniesFormValues = setNewCompanies({
    companyIndex,
    oldCompanies: currentState.formValue.companiesFormValues,
    newCompany: { ...oldCompany, professionalPartnerships: { ...formData } }
  })

  return {
    formValue: {
      ...currentState.formValue,
      companiesFormValues: newCompaniesFormValues
    }
  }
}
